<button class="pointerHover" (click)='onClick()'>
  <span>{{articles.length}}</span>
</button>